import React from 'react';
import { View } from '@applane/react-core-components';
import HomeStyle from './HomeStyle';

const CardBox = () => {
  return (
    <View style={HomeStyle.cardContainer}>
      <View style={HomeStyle.cardContent}>
        <View style={HomeStyle.cardHeader}>Card Header</View>
        <View style={HomeStyle.cardDiscription}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </View>
        <View style={HomeStyle.cardData}>
          <li>Certain Points with icons</li>
          <li>
            Certain Points with icons, Certain Points with icons and details.
          </li>
          <li>
            Certain Points with icons, Certain Points with icons and details.
          </li>
          <li>Certain Points with icons</li>
          <li>Certain Points with icons</li>
          <li>
            Certain Points with icons, Certain Points with icons and details.
          </li>
        </View>
      </View>
    </View>
  );
};
export default CardBox;
